firebird.config([
    '$provide',
    function ($provide) {
        $provide.decorator('emojiFilter', [
            '$delegate',
            function ($delegate) {
                return function (text) {
                    if (!text) return text;

                    var urlRegex = /(https?:\/\/[^\s]+)/g;
                    var parts = text.split(urlRegex);

                    for (var i = 0; i < parts.length; i++) {
                        urlRegex.lastIndex = 0;
                        if (!urlRegex.test(parts[i])) {
                            parts[i] = $delegate(parts[i]);
                        }
                    }

                    return parts.join('');
                };
            }
        ]);
    }
]);
